import { HttpClient } from '@angular/common/http';
import { AfterContentInit, Component } from '@angular/core';
import { MapsManagerService } from 'angular-cesium';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AreaTypeService } from 'src/app/shared/services/area-type.service';

@Component({
    selector: 'app-area-provider',
    templateUrl: './area-provider.component.html',
    styleUrls: ['./area-provider.component.scss'],
})
export class AreaProviderComponent implements AfterContentInit {
    viewer;
    showBoundaryStatus = false;
    quality = 'l';
    shapeTypeId = 1; //Default, IHO
    shapeType = 'iho'; //Default, IHO

    iho_boundary_label: any;
    fao_boundary_label: any;

    iho_boundary: any;
    fao_boundary: any;

    iho_boundary_loaded = false;
    fao_boundary_loaded = false;

    iho_promise;
    fao_promise;
    iho_source = new Cesium.GeoJsonDataSource('iho_data_source');
    fao_source = new Cesium.GeoJsonDataSource('fao_data_source');

    constructor(
        private mapsManagerService: MapsManagerService,
        private areaTypeService: AreaTypeService,
        private http: HttpClient
    ) {}

    ngAfterContentInit() {
        this.viewer = this.mapsManagerService.getMap().getCesiumViewer();

        // var iho_shape_urlpath = './assets/data/IHO_2MB_Simplify002.json';
        // var fao_shape_urlpath = './assets/data/FAO_1MB_Simplify0001.json';
        // var iho_shape_urlpath = './assets/data/iho_final_simplified.json';
        // var fao_shape_urlpath = './assets/data/fao_final_simplified.json';

        // this.getJson(iho_shape_urlpath).subscribe((data) => {
        //   const features = data.features;
        //   this.addDataToGlobe(features, 'iho');
        // });

        // this.getJson(fao_shape_urlpath).subscribe((data) => {
        //   const features = data.features;
        //   this.addDataToGlobe(features, 'fao');
        // });

        this.iho_promise = Cesium.IonResource.fromAssetId(371574).then(
            function (resource) {
                return Cesium.GeoJsonDataSource.load(resource, {
                    stroke: Cesium.Color.WHITE,
                    fill: Cesium.Color.WHITE.withAlpha(0.0),
                    strokeWidth: 1,
                });
            }
        );

        this.iho_promise
            .then((iho_dataSource) => {
                this.iho_boundary = iho_dataSource.entities;
                this.iho_boundary.show = false;
                this.generateLabel(this.iho_boundary);

                this.iho_boundary_loaded = true;

                if (this.iho_boundary_loaded && this.fao_boundary_loaded) {
                    this.areaTypeService.setDataSourceStatus(true);
                }

                return this.viewer.dataSources.add(iho_dataSource);
            })
            .otherwise(function (error) {
                console.log(error);
            });

        this.fao_promise = Cesium.IonResource.fromAssetId(371573).then(
            function (resource) {
                return Cesium.GeoJsonDataSource.load(resource, {
                    stroke: Cesium.Color.WHITE,
                    fill: Cesium.Color.WHITE.withAlpha(0.0),
                    strokeWidth: 1,
                });
            }
        );

        this.fao_promise
            .then((fao_dataSource) => {
                this.fao_boundary = fao_dataSource.entities;
                this.fao_boundary.show = false;
                this.generateLabel(this.fao_boundary);

                this.fao_boundary_loaded = true;

                if (this.iho_boundary_loaded && this.fao_boundary_loaded) {
                    this.areaTypeService.setDataSourceStatus(true);
                }

                return this.viewer.dataSources.add(fao_dataSource);
            })
            .otherwise(function (error) {
                console.log(error);
            });

        this.areaTypeService.getBoundaryStatus().subscribe((data) => {
            this.showBoundaryStatus = data.showBoundaryStatus;
            this.shapeTypeId = data.shapeTypeId;

            if (this.showBoundaryStatus != true) {
                this.iho_boundary.show = false;
                this.fao_boundary.show = false;
            } else {
                if (this.shapeTypeId == 1) {
                    this.iho_boundary.show = true;
                } else {
                    this.fao_boundary.show = true;
                }
                this.viewer.scene.requestRender();
            }
        });
    }

    generateLabel(boundaryObj: any) {
        const entities = boundaryObj.values;

        for (var i = 0; i < entities.length; i++) {
            const entity = entities[i];
            var name =
                entity.properties.ParentNAME +
                '\n' +
                entity.properties.ChildNAME;

            //Make sure it’s a polygon and doesn’t already have a position.
            if (!entity.position && entity.polygon) {
                var poly_center = Cesium.BoundingSphere.fromPoints(
                    entity.polygon.hierarchy.getValue().positions
                ).center;
                poly_center =
                    Cesium.Ellipsoid.WGS84.scaleToGeodeticSurface(poly_center);
                poly_center = Cesium.Cartographic.fromCartesian(poly_center);
                entity.position = Cesium.Cartesian3.fromRadians(
                    poly_center.longitude,
                    poly_center.latitude
                );
            }

            //Set up the label.
            var label = new Cesium.LabelGraphics();
            label.text = new Cesium.ConstantProperty(name);
            label.scaleByDistance = new Cesium.NearFarScalar(
                8500000,
                1.5,
                20000000,
                1.0
            );
            label.translucencyByDistance = new Cesium.NearFarScalar(
                8500000,
                1.0,
                20000000,
                0.2
            );
            label.font = new Cesium.ConstantProperty('12px sans-serif');
            label.fillColor = new Cesium.ConstantProperty(Cesium.Color.WHITE);
            label.style = new Cesium.ConstantProperty(Cesium.LabelStyle.FILL);
            entity.label = label;
        }
    }

    getJson(urlpath): Observable<any> {
        return this.http
            .get<any>(urlpath)
            .pipe(tap((_) => console.log(`get content, id`)));
    }

    // toggleVisibility(shapeType: string, visibility: boolean) {
    //   var boudaryPrimitiveCollection = this.iho_boundary;
    //   var labelPrimitiveCollection = this.iho_boundary_label;
    //   if (shapeType == 'fao') {
    //     boudaryPrimitiveCollection = this.fao_boundary;
    //     labelPrimitiveCollection = this.fao_boundary_label;
    //   }

    //   var len = boudaryPrimitiveCollection.length;
    //   for (var i = 0; i < len; ++i) {
    //     var p = boudaryPrimitiveCollection.get(i);
    //     p.show = visibility;
    //   }

    //   var label_len = labelPrimitiveCollection.length;
    //   for (var i = 0; i < label_len; ++i) {
    //     var p = labelPrimitiveCollection.get(i);
    //     p.show = visibility;
    //   }
    // }

    // addDataToGlobe(features, seaAreaType) {
    //   var labelCollection;

    //   if (seaAreaType == 'iho') {
    //     this.iho_boundary = new Cesium.PolylineCollection();
    //     this.iho_boundary_label = new Cesium.LabelCollection();
    //     labelCollection = this.iho_boundary_label;
    //   } else {
    //     this.fao_boundary = new Cesium.PolylineCollection();
    //     this.fao_boundary_label = new Cesium.LabelCollection();
    //     labelCollection = this.fao_boundary_label;
    //   }

    //   for (let i = 0; i < features.length; i++) {
    //     for (let j = 0; j < features[i].geometry.coordinates.length; j++) {
    //       const polygonArr = features[i].geometry.coordinates[j]
    //         .toString()
    //         .split(',')
    //         .map(data => {
    //           return parseFloat(data);
    //         });

    //       var poly_center = Cesium.BoundingSphere.fromPoints(
    //         Cesium.Cartesian3.fromDegreesArray(polygonArr)
    //       ).center;
    //       poly_center = Cesium.Ellipsoid.WGS84.scaleToGeodeticSurface(
    //         poly_center
    //       );
    //       poly_center = Cesium.Cartographic.fromCartesian(poly_center);

    //       labelCollection.add({
    //         //id: seaAreaType + '_label_' + i + '_' + j,
    //         show: false,
    //         position: Cesium.Cartesian3.fromRadians(
    //           poly_center.longitude,
    //           poly_center.latitude
    //         ),
    //         text:
    //           features[i].properties.ParentNAME +
    //           '\n' +
    //           features[i].properties.ChildNAME,
    //         font: '14px sans-serif',
    //         fillColor: Cesium.Color.WHITE,
    //         style: Cesium.LabelStyle.FILL,
    //         // scaleByDistance: new Cesium.NearFarScalar(
    //         //   8500000,
    //         //   1.5,
    //         //   20000000,
    //         //   1.0
    //         // ),
    //         translucencyByDistance: new Cesium.NearFarScalar(
    //           8500000,
    //           1.0,
    //           20000000,
    //           0.2
    //         ),
    //       });

    //       if (seaAreaType == 'iho') {
    //         this.iho_boundary.add({
    //           show: false,
    //           positions: Cesium.Cartesian3.fromDegreesArray(polygonArr),
    //           width: 1,
    //         });
    //       } else {
    //         this.fao_boundary.add({
    //           show: false,
    //           positions: Cesium.Cartesian3.fromDegreesArray(polygonArr),
    //           width: 1,
    //         });
    //       }
    //     }
    //   }

    //   if (seaAreaType == 'iho') {
    //     this.viewer.scene.primitives.add(this.iho_boundary);
    //     this.viewer.scene.primitives.add(this.iho_boundary_label);
    //   } else {
    //     this.viewer.scene.primitives.add(this.fao_boundary);
    //     this.viewer.scene.primitives.add(this.fao_boundary_label);
    //   }
    // }
}
